import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import * as Styles from './styles'

const PutRequestOnHoldConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasReasonError = errors.some(e => e.type === errorTypes.actionReasonEmpty)

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Motivo')}</Text>
      <InputWithLabel
        label={t('Motivo')}
        value={config.hold_reason || ''}
        onChange={e => onChangeConfig({ hold_reason: e.target.value })}
        maxLength={50}
        showCounter
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasReasonError}
        helperText={hasReasonError ? t('Este campo es obligatorio') : undefined}
      />
      <Alert type="info">
        {t(
          'El motivo se mostrará en la alerta correspondiente para aclarar por qué se ha puesto En espera la solicitud'
        )}
      </Alert>
    </Styles.Container>
  )
}

export default PutRequestOnHoldConfig
